// extracted by mini-css-extract-plugin
export var alertCountdown = "CountdownBadge-module--alertCountdown--c3ca4";
export var badgeContainer = "CountdownBadge-module--badgeContainer--b54eb";
export var tooltipContent = "CountdownBadge-module--tooltipContent--fae89";